module.exports = __webpack_public_path__ + "img/local-18.1246d80a.jpg";